// Libs
import React from 'react'
import api from '../../apiClient/v1'
// Componentes
import { AutoSizer, Table, Column } from 'react-virtualized'
import {
    ModalTrigger,
    ModalAgregarLocal,
    ModalEditarLocal,
    ModalPegarLocales,
    ModalDireccion
} from './Modales.jsx'
import { HeaderConBusqueda } from '../../components/shared/HeaderConBusqueda.jsx'
// Styles
import * as css from './mantenedorLocal.css'

export default class MantenedorLocales2 extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            idCliente: "1",
            localesRaw: [],
            locales: [],
            busquedaComuna: '',
        }
        this.seleccionarCliente = (evt)=>{
            const idCliente = evt.target.value
            this.setState({
                idCliente: idCliente,
                localesRaw: [],
                locales: []
            }, ()=>{
                this.fetchLocales()
            })
        }
        this.fetchLocales = ()=>{
            api.cliente(this.state.idCliente).getLocales()
                .then(locales=>{
                    this.setState({locales: locales, localesRaw: locales})
                })
                .catch(meh=>{})
        }
        this.actualizarLocal = (local)=>{
            let request = api.local.actualizar(local.idLocal, local)
            request
                .then(()=> this.fetchLocales())
                .catch(meh=>{})
            return request
        }
        this.agregarLocal = (local)=>{
            let request = api.local.nuevo(local)
            request
                .then(()=> this.fetchLocales())
                .catch(meh=>{})
            return request
        }
        this.agregarLocalesPegar = (locales)=>{
            let request = api.local.nuevos(locales)
            request
                .then(this.fetchLocales)
                .catch(err=>{})
            return request
        }
        this.realizarBusqueda = (field, originalSearch)=>{
            const value = typeof originalSearch === 'number' ? originalSearch : originalSearch.trim().toLowerCase();
            this.setState({[field]: value}, () => this.filtrarLocales());
        };
        this.guardarGeolocalizacion = (idLocal, lat, long) => {
            let request = api.local.geolocalizacion(idLocal, lat, long)
            request
                .then(()=> this.fetchLocales())
                .catch(meh=>{})
            return request
        }
        this.filtrarLocales = ()=> {
            this.setState({
                locales: this.state.localesRaw
                    //.filter(us=> us.RUN.indexOf(this.state.busquedaRUN)>=0)
                    //.filter(us=> us.apellidoPaterno.toLowerCase().indexOf(this.state.busquedaApellido)>=0  || us.apellidoMaterno.toLowerCase().indexOf(this.state.busquedaApellido)>=0)
                    //.filter(us=> us.nombre1.toLowerCase().indexOf(this.state.busquedaNombre)>=0  || us.nombre2.toLowerCase().indexOf(this.state.busquedaNombre)>=0)
                    //.filter(us=> us.captador.toLowerCase().indexOf(this.state.busquedaCaptador)>=0)
                    //.filter(us=> us.vigencia.toLowerCase().indexOf(this.state.busquedaVigencia)>=0)
                    //.filter(us=> us.isContractFile.toLowerCase().indexOf(this.state.searchStatusContract)>=0)
                    .filter(lo=> lo.comuna_nombre.toLowerCase().indexOf(this.state.busquedaComuna)>=0)
            })
        }
    }
    componentWillMount(){
        this.fetchLocales()
    }
    render(){
        const {
            busquedaComuna
        } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <h1>Mantenedor de Locales</h1>
                    </div>
                    <div className="col-md-6">
                        <div className="pull-right" style={{marginTop: '25px'}}>
                            <ModalTrigger>
                                {(isVisible, showModal, hideModal)=>
                                    <button className="btn btn-sm btn-success" onClick={showModal}>
                                        Agregar Local
                                        {isVisible && <ModalAgregarLocal
                                            agregarLocal={this.agregarLocal}
                                            hideModal={hideModal}
                                            idCliente={this.state.idCliente}
                                            jornadas={this.props.jornadas}
                                            comunas={this.props.comunas}
                                            formatoLocales={this.props.formatoLocales}
                                        />}
                                    </button>
                                }
                            </ModalTrigger>
                            <ModalTrigger>
                                {(isVisible, showModal, hideModal)=>
                                    <button className="btn btn-sm btn-success" onClick={showModal}>
                                        Pegar Locales
                                        {isVisible && <ModalPegarLocales
                                            agregarLocales={this.agregarLocalesPegar}
                                            hideModal={hideModal}
                                            idCliente={this.state.idCliente}
                                            jornadas={this.props.jornadas}
                                            comunas={this.props.comunas}
                                            formatoLocales={this.props.formatoLocales}
                                        />}
                                    </button>
                                }
                            </ModalTrigger>
                        </div>
                    </div>
                </div>
                <SelectorCliente
                    idClienteSeleccionado={this.state.idCliente}
                    seleccionarCliente={this.seleccionarCliente}
                    clientes={this.props.clientes}
                />
                <Locales
                    locales={this.state.locales}
                    jornadas={this.props.jornadas}
                    formatoLocales={this.props.formatoLocales}
                    comunas={this.props.comunas}
                    actualizarLocal={this.actualizarLocal}
                    busquedaComuna={busquedaComuna}
                    realizarBusqueda={this.realizarBusqueda.bind(this, 'busquedaComuna')}
                    guardar={this.guardarGeolocalizacion}
                />
            </div>
        )
    }
}

const SelectorCliente = ({idClienteSeleccionado, seleccionarCliente, clientes})=>
    <div className="row">
        <div className="col-sm-3 form-group ">
            <label className="control-label" htmlFor="cliente">Cliente</label>
            <select className="form-control" name="cliente"
                    value={idClienteSeleccionado}
                    onChange={seleccionarCliente}
            >
                <option value="-1" disabled>--</option>
                {clientes.map(cliente=>
                    <option key={cliente.idCliente} value={cliente.idCliente}>{`${cliente.nombreCorto} - ${cliente.nombre}`}</option>
                )}
            </select>
        </div>
    </div>

const Locales = ({locales, jornadas, formatoLocales, comunas, actualizarLocal, busquedaComuna, realizarBusqueda, guardar})=>
    <div style={{height: '80%'}} className={css.tablaMantenedorLocales}>
        <AutoSizer>
        {({height, width}) =>
            <Table
                
                // general
                height={height}
                width={width}
                // headers
                headerHeight={30}
                headerClassName={css.headerColumn}
                // rows
                rowCount={locales.length}
                rowGetter={({index})=> locales[index]}
                rowHeight={30}
                rowClassName={({index})=> index<0? css.headerRow : ((index%2===0)? css.evenRow : css.oddRow)} 
            >
                {/* Cliente */}
                <Column
                    dataKey='cliente' label="CL"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData.cliente.nombreCorto}
                    width={40}
                />
                {/* Ceco */}
                <Column
                    dataKey='numero' label="CECO"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    width={40}
                />
                {/* Nombre */}
                <Column
                    dataKey='nombre' label="Nombre"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    width={120}
                />
                {/* Formato Local */}
                <Column
                    dataKey='formatoLocal_nombre' label="Formato"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    width={120}
                />
                {/* Jornada */}
                <Column
                    dataKey='jornadaSugerida' label="Jornada"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    width={70}
                />
                {/* Hora Apertura */}
                <Column
                    dataKey='horaApertura' label="Apertura"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    width={70}
                />
                {/* Hora Cierre */}
                <Column
                    dataKey='horaCierre' label="Cierre"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    width={50}
                />
                {/* Email */}
                <Column
                    dataKey='emailContacto' label="Email"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    width={100}
                />
                {/* Telefono 1 */}
                <Column
                    dataKey='telefono1' label="Telefono"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    width={85}
                />
                {/* Telefono 2 */}
                <Column
                    dataKey='telefono2' label=""
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    width={85}
                />
                {/* Stock */}
                <Column
                    dataKey='stock' label="Stock"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    width={50}
                />
                {/* Comuna */}
                <Column
                    dataKey='comuna_nombre' label="Comuna"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                    headerRenderer={() =>
                        <HeaderConBusqueda
                            nombre="Comuna"
                            busqueda={busquedaComuna}
                            realizarBusqueda={realizarBusqueda}
                        />
                    }
                    width={100}
                />
                {/* Direccion */}
                <Column
                    dataKey='direccion' label="Dirección"
                    width={200}
                    flexGrow={1}
                    cellRenderer={({ rowData }) => {
                        const { direccion, gmap_lat, gmap_long, comuna_nombre, idLocal } = rowData;
                        if (gmap_lat && gmap_long) {
                            const url = `https://www.google.com/maps?q=${gmap_lat},${gmap_long}`;
                            return (
                                <a href={url} target="_blank" rel="noopener noreferrer">
                                {direccion} <span className='glyphicon glyphicon-map-marker'></span>
                                </a>
                            );
                        }
                        return (
                            <ModalTrigger>
                                {(isVisible, showModal, hideModal)=>
                                    <span style={{cursor: 'pointer'}} onClick={showModal}>
                                        {direccion}
                                        {isVisible && <ModalDireccion
                                            hideModal={hideModal}
                                            direccion={direccion}
                                            comuna={comuna_nombre}
                                            id={idLocal}
                                            onGuardar={guardar}
                                        />}
                                    </span>
                                }
                            </ModalTrigger>
                        )
                    }}
                />
                <Column
                    dataKey='direccion' label="Opciones"
                    cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) =>
                        <ModalTrigger>
                            {(isVisible, showModal, hideModal)=>
                                <button className="btn btn-xs btn-primary" onClick={showModal}>
                                    Editar
                                    {isVisible && <ModalEditarLocal
                                        local={rowData}
                                        hideModal={hideModal}
                                        jornadas={jornadas}
                                        comunas={comunas}
                                        formatoLocales={formatoLocales}
                                        actualizarLocal={actualizarLocal}
                                    />}
                                </button>
                            }
                        </ModalTrigger>
                    }
                    width={80}
                />
            </Table>
        }
    </AutoSizer>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/admin/mantenedorLocales2/MantenedorLocales2.jsx